<template>
  <div class="day-parts-legend">
    <div class="day-parts-legend__part"
         :class="{'day-parts-legend__part--selected': isSelected(part.id)}"
         v-for="part in sortedDayParts"
         @click="emitDayPart(part.id)">
      <span class="day-parts-legend__part-color" :style="{ backgroundColor: part.color }"></span>
      {{ part.name }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      parts: {
        type: Array,
        required: true
      },
      selectedParts: {
        type: Array,
        required: true
      }
    },
    computed: {
      sortedDayParts: function () {
        return this.sortDayParts(this.parts)
      }
    },
    methods: {
      emitDayPart (id) {
        this.$emit('day-part-click', id)
      },
      isSelected (id) {
        return this.selectedParts.indexOf(id) > -1
      },
      sortDayParts (dayparts) {
        let sortedOrder = []
        let sortOrder = [
          'Weekday Morning',
          'Weekend Daytime',
          'Weekday Daytime',
          'Early Fringe',
          'Prime Time',
          'Late Fringe'
        ]
        for (let so of sortOrder) {
          for (let dp of dayparts) {
            if (dp.name === so) {
              sortedOrder.push(dp)
              break
            }
          }
        }
        // just in case other day parts are added to the system
        for (let dp of dayparts) {
          let accepted = false
          for (let sd of sortedOrder) {
            if (dp.name === sd.name) {
              accepted = true
              break
            }
          }
          if (!accepted) {
            sortedOrder.push(dp)
          }
        }
        return sortedOrder
      }
    }
  }
</script>

<style lang="scss">
  .day-parts-legend {
    display: flex;
    align-items: center;
    line-height: rem(13);
    font-size: rem(13);
    padding-right: 50px;

    &__part {
      cursor: pointer;
      flex-grow: 1;
      flex-shrink: 1;

      &:hover {
        text-decoration: underline;
      }

      &--selected {
        opacity: 0.4;
      }
    }

    &__part + &__part {
      margin-left: rem(15);
    }

    &__part-color {
      display: inline-block;
      width: rem(12);
      height: rem(12);
      border-radius: rem(2);
    }
  }
</style>



// WEBPACK FOOTER //
// DayPartsLegend.vue?bcae3d58